import { apiClient } from '@/config/api';
import {
    Comment,
    CreateCommentDto,
    GetMovieCommentsDto,
    CommentListResponse,
    CommentWithMovieListResponse,
    CommentFilters,
} from '@/types/comment';

class CommentService {
    // Public: Guest tạo bình luận
    async createComment(createCommentDto: CreateCommentDto): Promise<Comment> {
        const response: any = await apiClient.post<Comment>('/comments', createCommentDto);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi tạo bình luận');
        }
        return response.data;
    }

    // Public: Lấy danh sách bình luận đã duyệt cho một phim
    async getMovieComments(query: GetMovieCommentsDto): Promise<CommentListResponse> {
        const params = new URLSearchParams();
        params.append('movie', query.movie);
        if (query.page) params.append('page', query.page.toString());
        if (query.limit) params.append('limit', query.limit.toString());

        const response: any = await apiClient.get<CommentListResponse>(`/comments/movie?${params}`);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy danh sách bình luận');
        }
        return response.data;
    }

    // Admin: Lấy danh sách bình luận với filter
    async getComments(filters: CommentFilters = {}): Promise<CommentListResponse> {
        const params = new URLSearchParams();
        if (filters.status) params.append('status', filters.status);
        if (filters.page) params.append('page', filters.page.toString());
        if (filters.limit) params.append('limit', filters.limit.toString());

        const response: any = await apiClient.get<CommentListResponse>(`/comments?${params}`);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy danh sách bình luận');
        }
        return response.data;
    }

    // Admin: Duyệt bình luận
    async approveComment(id: string): Promise<Comment> {
        const response: any = await apiClient.put<Comment>(`/comments/${id}/approve`);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi duyệt bình luận');
        }
        return response.data;
    }

    // Admin: Từ chối bình luận
    async rejectComment(id: string): Promise<Comment> {
        const response: any = await apiClient.put<Comment>(`/comments/${id}/reject`);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi từ chối bình luận');
        }
        return response.data;
    }

    // Admin: Xóa bình luận
    async deleteComment(id: string): Promise<void> {
        const response: any = await apiClient.delete(`/comments/${id}`);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi xóa bình luận');
        }
    }

    // Helper: Lấy thông tin phim cho bình luận (không cần vì backend đã populate)
    async getCommentsWithMovieDetails(filters: CommentFilters = {}): Promise<CommentWithMovieListResponse> {
        const commentsResponse = await this.getComments(filters);

        // Backend đã trả về đầy đủ thông tin, chỉ cần cast type
        return commentsResponse as CommentWithMovieListResponse;
    }
}

export const commentService = new CommentService();
